import React from 'react';
import { motion } from 'framer-motion';

const SERVICES_LINKS = [
  { label: 'Design & Engineering',    href: '#services' },
  { label: 'Operations & Maintenance', href: '#services' },
  { label: 'Safety Training',          href: '#training' },
  { label: 'Manpower Solutions',       href: '#services' },
  { label: 'Safety Products',          href: '#products' },
];

const COMPANY_LINKS = [
  { label: 'About Us',       href: '#about' },
  { label: 'Our Clients',    href: '#clients' },
  { label: 'Contact',        href: '#contact' },
  { label: 'Payroll Portal', href: 'http://www.eazyworldehsengineering.com/payroll/' },
  { label: 'Vasavi Computers', href: 'http://www.vasavicomputers.com/' },
];

const SOCIALS = [
  { icon: '💼', label: 'LinkedIn', href: '#' },
  { icon: '📘', label: 'Facebook', href: '#' },
  { icon: '🐦', label: 'Twitter',  href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container-xl px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        {/* Top accent */}
        <div className="h-1 w-16 bg-brand-orange rounded-full mb-12" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-3 mb-5">
              <img
                src="/images/eazyworld_logo.png"
                alt="Eazyworld EHS Engineering"
                className="h-14 w-auto object-contain drop-shadow-sm shrink-0"
                style={{ maxWidth: '72px' }}
              />
              <div className="leading-tight">
                <p className="text-base font-black uppercase text-brand-orange tracking-wide whitespace-nowrap">EAZYWORLD</p>
                <p className="text-[10px] font-bold tracking-widest text-gray-500 uppercase whitespace-nowrap">EHS ENGINEERING</p>
              </div>
            </a>
            <p className="text-brand-subtle text-sm leading-relaxed mb-6">
              A fast-developing EHS engineering organisation delivering excellence in safety training and industrial operations across India since 2012.
            </p>
            <div className="flex gap-3">
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="w-9 h-9 rounded-xl bg-white border border-gray-200 flex items-center justify-center text-base hover:border-brand-orange hover:bg-orange-50 transition-all duration-300"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-brand-heading font-semibold text-sm tracking-wide mb-5">Services</h4>
            <ul className="space-y-3">
              {SERVICES_LINKS.map(l => (
                <li key={l.label}>
                  <a href={l.href} className="text-brand-subtle text-sm hover:text-brand-orange transition-colors duration-200 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-3 h-px bg-brand-orange transition-all duration-300 overflow-hidden" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-brand-heading font-semibold text-sm tracking-wide mb-5">Company</h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map(l => (
                <li key={l.label}>
                  <a href={l.href} className="text-brand-subtle text-sm hover:text-brand-orange transition-colors duration-200 flex items-center gap-2 group">
                    <span className="w-0 group-hover:w-3 h-px bg-brand-orange transition-all duration-300 overflow-hidden" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-brand-heading font-semibold text-sm tracking-wide mb-5">Contact</h4>
            <ul className="space-y-3">
              <li><a href="tel:+919025321004" className="text-brand-subtle text-sm hover:text-brand-orange transition-colors">+91 - 9025321004</a></li>
              <li><a href="mailto:info@eazyworldehsengineering.com" className="text-brand-subtle text-sm hover:text-brand-orange transition-colors break-all">info@eazyworldehsengineering.com</a></li>
              <li><span className="text-brand-subtle text-sm">Perambur, Chennai – 600 011</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-brand-subtle text-xs">© 2024 Eazyworld EHS Engineering Pvt. Ltd. All rights reserved.</p>
          <p className="text-brand-subtle text-xs">
            Designed & Maintained by{' '}
            <a href="http://www.vasavicomputers.com/" className="text-brand-orange hover:underline">Vasavi Computers, Chennai</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
